import type { LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare";
import { redirect } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import Container from "~/components/layout/Container";
import { buildMeta, descriptionFromHtml } from "~/lib/seo";
import { slugify } from "~/lib/slugify";
import { references } from "../_index";
import References from "../features/References";
import Slogans from "../features/Slogans";
import { MekanikTesisatListesi } from "./_index";

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const service = MekanikTesisatListesi.find((service) => service.id === Number(params.id));
  if (!service) {
    throw new Response("Not Found", { status: 404 });
  }
  // Canonical slug kontrolü: yanlış slug ile gelindiyse doğru URL'ye 301 yönlendir.
  const canonicalSlug = slugify(service.title);
  if (params.slug !== canonicalSlug) {
    throw redirect(`/mekanik-tesisatlar/${canonicalSlug}/${service.id}`, 301);
  }
  return {
    service,
    services: MekanikTesisatListesi,
    references: references
  }
}
export const meta: MetaFunction<typeof loader> = ({ data }) => {
  const service = data?.service;
  if (!service) {
    return buildMeta({
      title: "Hizmet Bulunamadı | Al-De Mühendislik",
      description: "Aradığınız mekanik tesisat hizmeti bulunamadı.",
      path: "/mekanik-tesisatlar",
    });
  }
  return buildMeta({
    title: `${service.title} | Manisa, İzmir, Turgutlu | Al-De Mühendislik`,
    description: descriptionFromHtml(service.description),
    path: `/mekanik-tesisatlar/${slugify(service.title)}/${service.id}`,
    image: service.image,
    type: "article",
  })
}
export default function MekanikTesisatlarDetay() {
  const { service, references } = useLoaderData<typeof loader>();
  return (
    <div className="mt-48">
      <div className="">
        <Container className="flex-wrap mb-20">
          <h1 className="text-3xl w-full justify-center font-black font-raleway text-center text-[32px] mb-5">Mekanik Tesisatlar</h1>
          <p className="text-center mb-10 text-[24px] font-lato text-[#444444]">
            Al-De Mühendislik olarak, modern mekanik çözümlerle konforlu ve güvenli yaşam alanları sağlamak için hizmetler sunuyoruz.
          </p>
          <div className="flex flex-wrap items-start">
            <img src={service.image} alt={service.title} width={400} height={300} loading="lazy" className="group-hover:shadow-lg w-full md:w-1/3" />
            <div className="md:pl-5 w-full md:w-2/3">
              <h3 className="tet-base md:text-2xl font-black font-raleway text-[#16437c]">{service.title}</h3>
              <div key={service.title} className="w-full text-[14px] font-lato text-[#333333]">
                <span dangerouslySetInnerHTML={{ __html: service.description }} className="block mt-2 mb-8 text-base [&_h3]:text-[#16437c] [&_h4]:text-[#16437c] [&_h3]:text-[16px] [&_h3]:font-bold [&_h3]:mt-4 [&_h3]:font-raleway [&_h4]:text-[14px] [&_h4]:font-bold [&_h4]:mt-4 [&_h4]:font-raleway [&_li]:pb-4 [&_p]:pb-4 [&_li_strong]:font-semibold [&_strong]:text-[#16437c] [&_strong]:text-[16px] [&_strong]:font-bold [&_strong]:mt-4 [&_strong]:font-raleway [&_strong]:leading-24" />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <Slogans />
      {/* <MekanikTesisatlarComponent services={services} /> */}
      <References references={references} />
    </div>
  )
}
